import { useCallback } from "react";
import { useOrg } from "@/contexts/OrgContext";

/**
 * Returns a helper that prefixes any internal path with the current tenant slug.
 * Usage:
 *   const tPath = useTenantPath();
 *   <Link to={tPath("/eventos/123")} />
 *   navigate(tPath("/promotores"))
 *
 * If no org is loaded yet (eg. transitional render before OrgContext resolves),
 * we still return the path unprefixed so links work after the org loads.
 */
export function useTenantPath() {
  const { org } = useOrg();
  const slug = org?.slug;
  return useCallback(
    (path) => {
      const clean = (path || "").startsWith("/") ? path : `/${path || ""}`;
      if (!slug) return clean;
      return `/${slug}${clean === "/" ? "/dashboard" : clean}`;
    },
    [slug],
  );
}
